import { useEffect, useState } from "react";
import withAuth from "./withAuth";
import module from "./Accounts.module.css";
import { Alert, Button, Snackbar, Typography } from "@mui/material";
import MonthReport from "../components/accounts/MonthReport";
import InvitationCard from "../components/accounts/InvitationCard";
import ListRow from "../components/atomic/ui/ListRow";
import TopGreen from "../components/atomic/ui/TopGreen";
import { Auth } from "aws-amplify";
import { Link, useNavigate } from "react-router-dom";

function Accounts() {
  const [user, setUser] = useState(null);
  const [userAge, setUserAge] = useState(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const userBirthdate = user.attributes.birthdate;
      setUserAge(userBirthdate);
      setUser(user);
    } catch (e) {
      console.log(e);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  useEffect(() => {
    document.body.style.backgroundColor = "#f5f5f5";
    getUser();
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleSignOut = async () => {
    await Auth.signOut();
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <div className={module.container}>
        <div className={module.contents}>
          <TopGreen>
            <Typography>
              こんにちは
              {user &&
                user.attributes &&
                user.attributes["family_name"] &&
                `、${user.attributes["family_name"]}さん`}
            </Typography>
          </TopGreen>
          <MonthReport userAge={userAge}/>
          <InvitationCard />
          <div>
            <ListRow
              key="news"
              text="お知らせ"
              onClick={() => handleNavigate("/news")}
              isSmall
            />
            <ListRow
              key="history"
              text="報酬履歴"
              onClick={() => handleNavigate("/mypage/history")}
              isSmall
            />
            <ListRow
              key="setting/reword"
              text="報酬設定"
              onClick={() => handleNavigate("/mypage/reward/setting")}
              isSmall
            />
            <ListRow
              key="faq"
              text="よくあるご質問"
              onClick={() => handleNavigate("/faq")}
              isSmall
            />
            <ListRow
              key="contact"
              text="お問合せ"
              onClick={() => handleNavigate("/contact")}
              isSmall
            />
          </div>
          <div className={module.logout}>
            <Typography
              color="secondary"
              fontWeight={"bold"}
              onClick={handleSignOut}
            >
              ログアウト
            </Typography>
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        onClose={handleClose}
        key={"top" + "center"}
        security="warning"
        autoHideDuration={6000}
      >
        <Alert severity="warning">
          再度ログインしてください
          <Button
            variant="outlined"
            sx={{ padding: "2px 8px", marginLeft: "8px" }}
            LinkComponent={Link}
            to={"/login"}
          >
            →戻る
          </Button>
        </Alert>
      </Snackbar>
    </>
  );
}

export default withAuth(Accounts);
